import LegalPageLayout from './LegalPageLayout';

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout
      title="Aviso de Privacidad"
      updatedAt="22 de julio de 2026"
      description="Aviso de privacidad de CavernicolApp conforme a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP)."
    >
      <p>
        En cumplimiento de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares
        (LFPDPPP) y su Reglamento, ponemos a tu disposición el presente Aviso de Privacidad para informarte
        cómo tratamos tus datos personales al usar <strong>CavernicolApp</strong>.
      </p>

      <h2>1. Responsable del tratamiento</h2>
      <div className="legal-page__entity-card">
        <h3>Dragon Technologies, S.A.P.I. de C.V.</h3>
        <p>
          RFC: DTE220909DT1<br />
          Domicilio: Río Nazas 42, Despacho 4-B, Colonia Cuauhtémoc, Alcaldía Cuauhtémoc,
          C.P. 06500, Ciudad de México, México.
        </p>
      </div>
      <p>
        Como corresponsable de infraestructura y procesamiento de pagos internacionales:
      </p>
      <div className="legal-page__entity-card">
        <h3>Dragon Technologies LLC</h3>
        <p>
          EIN: 33-2352150<br />
          Domicilio: 8131 W Hausman Rd Ste 102, San Antonio, TX 78249, Estados Unidos.
        </p>
      </div>

      <h2>2. ¿Qué datos personales tratamos?</h2>
      <p>Este aviso distingue dos tipos de personas cuyos datos podemos tratar:</p>
      <h3>a) Usuarios de la plataforma</h3>
      <p>
        Si te registras o usas CavernicolApp como parte de un negocio suscrito (dueño, administrador o
        colaborador), recabamos: nombre, correo electrónico, teléfono, cargo, credenciales de acceso, datos de
        facturación y método de pago (procesado por nuestros proveedores de pago; no almacenamos números
        completos de tarjeta), e información técnica de uso (dirección IP, dispositivo, registros de sesión con
        fines de seguridad).
      </p>
      <h3>b) Datos de terceros (tus propios clientes y prospectos)</h3>
      <p>
        Si eres un negocio suscrito, tú puedes cargar o generar en la plataforma datos de tus propios clientes,
        prospectos o pacientes (nombre, teléfono, correo, historial de conversaciones, citas, etc.). Respecto de
        esos datos, <strong>Dragon Technologies actúa como encargado del tratamiento por tu instrucción</strong>,
        no como responsable — eres tú quien debe contar con el aviso de privacidad y la base legal frente a esas
        personas. No usamos esos Datos de Terceros para fines distintos a prestarte el Servicio (por ejemplo,
        entrenar modelos de IA de terceros con tus datos sin tu autorización, o venderlos).
      </p>

      <h2>3. Finalidades del tratamiento</h2>
      <p><strong>Finalidades primarias (necesarias para el Servicio):</strong></p>
      <ul>
        <li>Crear y administrar tu cuenta y suscripción.</li>
        <li>Prestar las funcionalidades del Servicio (CRM, agenda, conversaciones, automatización, IA).</li>
        <li>Procesar pagos y facturación.</li>
        <li>Brindar soporte técnico y atención a solicitudes.</li>
        <li>Cumplir obligaciones legales y fiscales.</li>
        <li>Prevenir fraude y proteger la seguridad de la plataforma.</li>
      </ul>
      <p><strong>Finalidades secundarias (puedes oponerte sin afectar el Servicio):</strong></p>
      <ul>
        <li>Enviarte comunicaciones sobre nuevas funciones o mejoras al producto.</li>
        <li>Invitarte a encuestas de satisfacción o estudios de mercado.</li>
      </ul>
      <p>
        Para oponerte a las finalidades secundarias, escríbenos a
        <a href="mailto:contacto@cavernicolacreativo.com"> contacto@cavernicolacreativo.com</a>.
      </p>

      <h2>4. Transferencias de datos</h2>
      <p>
        Podemos compartir tus datos con las siguientes categorías de terceros, únicamente para las finalidades
        aquí descritas: (i) Dragon Technologies LLC (EE. UU.), como corresponsable de infraestructura y
        procesamiento de pagos internacionales; (ii) proveedores de infraestructura en la nube, mensajería
        (Meta/WhatsApp, Twilio), inteligencia artificial y pasarelas de pago, únicamente para operar el
        Servicio que contrataste; (iii) autoridades competentes cuando exista requerimiento legal válido. No
        vendemos tus datos personales a terceros.
      </p>

      <h2>5. Uso de cookies y tecnologías similares</h2>
      <p>
        Usamos cookies estrictamente necesarias para mantener tu sesión iniciada de forma segura (autenticación,
        prevención de fraude) y, en su caso, cookies analíticas para entender el uso de la plataforma y
        mejorarla. Puedes gestionar las cookies desde la configuración de tu navegador; deshabilitar las cookies
        necesarias puede impedir el uso del Servicio.
      </p>

      <h2>6. Derechos ARCO y revocación del consentimiento</h2>
      <p>
        Tienes derecho a Acceder, Rectificar y Cancelar tus datos personales, así como a Oponerte al tratamiento
        de los mismos (derechos "ARCO"), y a revocar el consentimiento que en su caso nos hayas otorgado. Para
        ejercer estos derechos, envía tu solicitud a
        <a href="mailto:contacto@cavernicolacreativo.com"> contacto@cavernicolacreativo.com</a>, indicando: (a)
        tu nombre completo y correo con el que te identificas en la plataforma, (b) el derecho que deseas
        ejercer, (c) copia de una identificación oficial que acredite tu identidad. Responderemos dentro de los
        plazos que marca la LFPDPPP.
      </p>

      <h2>7. Menores de edad</h2>
      <p>
        CavernicolApp está dirigido a negocios y profesionales; no está diseñado para ser usado por menores de
        edad. No recabamos intencionalmente datos personales de menores de edad como usuarios de la plataforma.
      </p>

      <h2>8. Cambios a este aviso</h2>
      <p>
        Podemos modificar este Aviso de Privacidad para reflejar cambios en nuestras prácticas o en la
        legislación aplicable. Publicaremos cualquier actualización en esta misma página con su fecha de
        vigencia.
      </p>

      <p className="legal-page__note">
        Este documento es una plantilla estándar conforme a la LFPDPPP y no sustituye una revisión por un
        abogado especializado en protección de datos — te recomendamos validarlo con asesoría legal antes de
        depender de él frente a una autoridad o auditoría.
      </p>
    </LegalPageLayout>
  );
}
